// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/RobotoCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/RobotoCondensed-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/RobotoCondensed-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/RobotoCondensed-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* This file contains global variables based in the marketplace theme defined by
* 100 Ladrillos design system.
*/
/*
* ------------------------------------------------------------------------------
* Colors
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Typography
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Layout
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Icon sizes
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Shape
* ------------------------------------------------------------------------------
*/
/*
* ------------------------------------------------------------------------------
* Breakpoints
* ------------------------------------------------------------------------------
*/
/*
* NOTE: The width and style of the font has been set using font-face in the fonts.scss
* file. However, when the main font cannot be loaded those styles are not applied to
* the optional fonts, because they must be specified each time the font styles are
* assigned. To ensure the correct styles are applied, this mixin should be used.
*/
/*
* NOTE: The following mixin can be used to calculate the size of any css property
* in rem, however, the design system defines that only the font sizes would be
* calculated in REM to give the user the opportunity to change the size by
* configuring the browser.
*/
@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'RobotoItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: 'RobotoMedium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'RobotoMediumItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'RobotoBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'RobotoBoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: 'RobotoCondensed';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'RobotoCondensedItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: 'RobotoCondensedBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'RobotoCondensedBoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-weight: 700;
  font-style: italic;
}

html {
  /*
  * NOTE: Only in this case should the third parameter be sent to toRem mixin.
  * The base font size unit is 14px, this was defined by our designer, but
  * in this case we are calculating the size of the html element and calculation
  * is done based on the browser unit which is 16px is most cases.
  */
  font-size: 16px;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  height: 100%;
  scroll-behavior: smooth;
  color: #3E3E3E;
  letter-spacing: 0px;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  background-color: #f8f8f8;
}

strong {
  font-family: 'RobotoBold', arial, sans-serif;
  font-weight: 700;
  font-style: normal;
}

b {
  font-family: 'RobotoBold', arial, sans-serif;
  font-weight: 700;
  font-style: normal;
}

p {
  font-size: 0.875rem;
}

span {
  font-size: 0.875rem;
}

#app {
  height: 100%;
  width: 100%;
}

* {
  box-sizing: border-box;
}

.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.align-center {
  align-items: center;
}

.align-self-center {
  align-self: center;
}

.space-between {
  justify-content: space-between;
}

.block {
  display: block;
}

.grid {
  display: -ms-grid;
  display: grid;
}

.row {
  width: 100%;
  display: block;
  clear: both;
}

.margin-0 {
  margin: 0;
}

.margin-t-1 {
  margin-top: 0.5rem;
}

.margin-t-2 {
  margin-top: 0.75rem;
}

.margin-t-3 {
  margin-top: 1rem;
}

.margin-t-4 {
  margin-top: 1.25rem;
}

.margin-t-5 {
  margin-top: 1.5rem;
}

.margin-t-6 {
  margin-top: 1.75rem;
}

.margin-t-7 {
  margin-top: 2rem;
}

.margin-r-1 {
  margin-right: 0.5rem;
}

.margin-r-2 {
  margin-right: 0.75rem;
}

.margin-r-3 {
  margin-right: 1rem;
}

.margin-r-4 {
  margin-right: 1.25rem;
}

.margin-r-5 {
  margin-right: 1.5rem;
}

.margin-r-6 {
  margin-right: 1.75rem;
}

.margin-r-7 {
  margin-right: 2rem;
}

.margin-b-1 {
  margin-bottom: 0.5rem;
}

.margin-b-2 {
  margin-bottom: 0.75rem;
}

.margin-b-3 {
  margin-bottom: 1rem;
}

.margin-b-4 {
  margin-bottom: 1.25rem;
}

.margin-b-5 {
  margin-bottom: 1.5rem;
}

.margin-b-6 {
  margin-bottom: 1.75rem;
}

.margin-b-7 {
  margin-bottom: 2rem;
}

.margin-l-1 {
  margin-left: 0.5rem;
}

.margin-l-2 {
  margin-left: 0.75rem;
}

.margin-l-3 {
  margin-left: 1rem;
}

.margin-l-4 {
  margin-left: 1.25rem;
}

.margin-l-5 {
  margin-left: 1.5rem;
}

.margin-l-6 {
  margin-left: 1.75rem;
}

.margin-l-7 {
  margin-left: 2rem;
}

.text-error {
  font-size: 13px;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  margin-bottom: 0;
  text-align: center;
  color: #a1062c;
}

.required-symbol {
  color: #ff5a60;
}

/*
* NOTE: The width and style of the font has been set using font-face in the fonts.scss
* file. However, when the main font cannot be loaded those styles are not applied to
* the optional fonts, because they must be specified each time the font styles are
* assigned. To ensure the correct styles are applied, this mixin should be used.
*/
/*
* NOTE: The following mixin can be used to calculate the size of any css property
* in rem, however, the design system defines that only the font sizes would be
* calculated in REM to give the user the opportunity to change the size by
* configuring the browser.
*/
@keyframes frontend_web-app_src_sass_fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes frontend_web-app_src_sass_fadeInRight {
  from {
    transform: translateX(500px);
    opacity: 0.5;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes frontend_web-app_src_sass_fadeOutRight {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(500px);
  }
}

/*
* This file contains global classes based in the theme defined by 100 Ladrillos
* design system.
*/
.h1 {
  font-size: 1.375rem;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #3E3E3E;
  letter-spacing: 0.4px;
}

.h2 {
  font-size: 1.25rem;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #3E3E3E;
  letter-spacing: 0px;
}

.h3 {
  font-size: 1.125rem;
  font-family: 'RobotoMedium', arial, sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #3E3E3E;
  letter-spacing: 0px;
}

.subtitle {
  font-size: 0.875rem;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #7E7C7C;
  letter-spacing: 0.4px;
}

.body1 {
  font-size: 0.875rem;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #3E3E3E;
  letter-spacing: 0px;
}

.body2 {
  font-size: 0.875rem;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #3E3E3E;
  letter-spacing: 0.4px;
}

.body3 {
  font-size: 0.875rem;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #7E7C7C;
  letter-spacing: 0.4px;
}

.card {
  background-color: #FFFFFF;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 0 6px 0 rgba(243, 243, 243, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/sass/theme-variables.scss","webpack://./src/sass/index.scss","webpack://./src/sass/mixins.scss","webpack://./src/sass/fonts.scss","webpack://./src/sass/main.scss","webpack://./src/sass/variables.scss","webpack://./src/sass/globals.scss","webpack://./src/sass/animations.scss","webpack://./src/sass/theme-classes.scss"],"names":[],"mappings":"AAAA;;;CCGC;ADED;;;;CCGC;AD0BD;;;;CCrBC;ADyFD;;;;CCpFC;ADkGD;;;;CC7FC;ADuGD;;;;CClGC;ADyGD;;;;CCpGC;ACaD;;;;;CDPC;AC2ED;;;;;CDrEC;AE7CD;EACE,qBAAqB;EACrB,4CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,2BAA2B;EAC3B,4CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,2BAA2B;EAC3B,4CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,iCAAiC;EACjC,4CAAmD;EACnD,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,yBAAyB;EACzB,4CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,+BAA+B;EAC/B,4CAAiD;EACjD,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,8BAA8B;EAC9B,4CAAuD;EACvD,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,oCAAoC;EACpC,4CAAsD;EACtD,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,kCAAkC;EAClC,4CAAoD;EACpD,gBAAgB;EAChB,kBAAkB;AF+CpB;;AE5CA;EACE,wCAAwC;EACxC,4CAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AF+CpB;;AGlHA;EACE;;;;;GHyHC;EGnHD,eAAe;EF+Cb,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EE9CpB,YAAY;EACZ,uBAAuB;EACvB,cJEa;EIDb,mBAAiE;AHsHnE;;AGnHA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,yBCiBY;AJqGd;;AGnHA;EFsDI,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;ADiEtB;;AGrHA;EFkDI,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;ADuEtB;;AGvHA;EFyFE,mBAAoC;ADkCtC;;AGvHA;EFqFE,mBAAoC;ADsCtC;;AGvHA;EACE,YAAY;EACZ,WAAW;AH0Hb;;AGvHA;EACE,sBAAsB;AH0HxB;;AKxKA;EAEI,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;AL0KjB;;AK/KA;EASI,sBAAsB;AL0K1B;;AKnLA;EAaI,mBAAmB;AL0KvB;;AKvLA;EAiBI,kBAAkB;AL0KtB;;AK3LA;EAqBI,8BAA8B;AL0KlC;;AK/LA;EAyBI,cAAc;AL0KlB;;AKnMA;EA6BI,iBAAiB;EACjB,aAAa;AL0KjB;;AKxMA;EAkCI,WAAW;EACX,cAAc;EACd,WAAW;AL0Kf;;AK9MA;EAwCI,SAAS;AL0Kb;;AKlNA;EA4CI,kBAAkB;AL0KtB;;AKtNA;EAgDI,mBAAmB;AL0KvB;;AK1NA;EAoDI,gBAAgB;AL0KpB;;AK9NA;EAwDI,mBAAmB;AL0KvB;;AKlOA;EA4DI,kBAAkB;AL0KtB;;AKtOA;EAgEI,mBAAmB;AL0KvB;;AK1OA;EAoEI,gBAAgB;AL0KpB;;AK9OA;EAwEI,oBAAoB;AL0KxB;;AKlPA;EA4EI,qBAAqB;AL0KzB;;AKtPA;EAgFI,kBAAkB;AL0KtB;;AK1PA;EAoFI,qBAAqB;AL0KzB;;AK9PA;EAwFI,oBAAoB;AL0KxB;;AKlQA;EA4FI,qBAAqB;AL0KzB;;AKtQA;EAgGI,kBAAkB;AL0KtB;;AK1QA;EAoGI,qBAAqB;AL0KzB;;AK9QA;EAwGI,sBAAsB;AL0K1B;;AKlRA;EA4GI,mBAAmB;AL0KvB;;AKtRA;EAgHI,sBAAsB;AL0K1B;;AK1RA;EAoHI,qBAAqB;AL0KzB;;AK9RA;EAwHI,sBAAsB;AL0K1B;;AKlSA;EA4HI,mBAAmB;AL0KvB;;AKtSA;EAgII,mBAAmB;AL0KvB;;AK1SA;EAoII,oBAAoB;AL0KxB;;AK9SA;EAwII,iBAAiB;AL0KrB;;AKlTA;EA4II,oBAAoB;AL0KxB;;AKtTA;EAgJI,mBAAmB;AL0KvB;;AK1TA;EAoJI,oBAAoB;AL0KxB;;AK9TA;EAwJI,iBAAiB;AL0KrB;;AKlUA;EA4JI,eAAe;EJtGf,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EIsGlB,gBAAgB;EAChB,kBAAkB;EAClB,cD1Ge;AJsRnB;;AK5UA;EAoKI,cDtJmB;AJkUvB;;AClSA;;;;;CDySC;ACrOD;;;;;CD2OC;AM7VD;EACE;IACE,UAAU;EN+VZ;EM5VA;IACE,UAAU;EN8VZ;AACF;;AM3VA;EACE;IACE,4BAA4B;IAC5B,YAAY;EN8Vd;EM3VA;IACE,wBAAwB;IACxB,UAAU;EN6VZ;AACF;;AM1VA;EACE;IACE,UAAU;IACV,wBAAwB;EN6V1B;EM1VA;IACE,UAAU;IACV,4BAA4B;EN4V9B;AACF;;AO3XA;;;CPgYC;AO3XD;ENoHE,mBAAoC;EAnElC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EM9ClB,cRIW;EQHX,qBAA8D;AP6XlE;;AOnYA;ENoHE,kBAAoC;EAnElC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EMtClB,cRJW;EQKX,mBAA8D;AP8XlE;;AO5YA;ENoHE,mBAAoC;EAvDlC,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;EM1ClB,cRZW;EQaX,mBAA8D;AP+XlE;;AOrZA;ENoHE,mBAAoC;EAnElC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EMtBlB,cRrBW;EQsBX,qBAAoE;APgYxE;;AO9ZA;ENoHE,mBAAoC;EAnElC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EMdlB,cR5BW;EQ6BX,mBAAiE;APiYrE;;AOvaA;ENoHE,mBAAoC;EAnElC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EMNlB,cRpCW;EQqCX,qBAAiE;APkYrE;;AOhbA;ENoHE,mBAAoC;EAnElC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EMElB,cR7CW;EQ8CX,qBAAiE;APmYrE;;AOzbA;EA0DI,yBR/CW;EQgDX,yBRtDW;EQuDX,kBAA8C;EAC9C,sBAAsB;EACtB,8CAA8C;APmYlD","sourcesContent":["/*\n* This file contains global variables based in the marketplace theme defined by\n* 100 Ladrillos design system.\n*/\n\n/*\n* ------------------------------------------------------------------------------\n* Colors\n* ------------------------------------------------------------------------------\n*/\n$grayC: #EAEAEA;\n$grayE: #BDBCBC;\n$grayG: #8C8C8C;\n$grayH: #7E7C7C;\n$grayI: #3E3E3E;\n$grayJ: #4A4A4A;\n$white: #FFFFFF;\n$green1: #47CBC3;\n$pink-dark: #F69699;\n$green: #65b212;\n$coral-pink: #FF5A60;\n$alternative-2-dark: #e59206;\n\n$alternative3: $blue;\n$alternative3-light: $blueLight;\n$alternative1-main: $green1;\n$disabled-main: $grayC;\n$disabled-contrast: $grayG;\n$hbBackgroundA: $white;\n$shape: $grayC;\n$secondary-dark: $pink-dark;\n$alternative4: $green;\n$primary-main: $coral-pink;\n$info-main: $blue;\n/*\n* ------------------------------------------------------------------------------\n* Typography\n* ------------------------------------------------------------------------------\n*/\n$typography-h1: (\n  'font-size': 22,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n$typography-h2: (\n  'font-size': 20,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0,\n  'font-style': 'normal',\n);\n\n$typography-h3: (\n  'font-size': 18,\n  'font-family': 'RobotoMedium',\n  'font-weigth': 500,\n  'color': $grayI,\n  'letter-spacing': 0,\n  'font-style': 'normal',\n);\n\n$typography-subtitle: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayH,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n$typography-body1: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0,\n  'font-style': 'normal',\n);\n\n$typography-body2: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayI,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n$typography-body3: (\n  'font-size': 14,\n  'font-family': 'Roboto',\n  'font-weigth': 400,\n  'color': $grayH,\n  'letter-spacing': 0.4,\n  'font-style': 'normal',\n);\n\n/*\n* ------------------------------------------------------------------------------\n* Layout\n* ------------------------------------------------------------------------------\n*/\n$layout-unit: 8;\n$layout-unit-small: 4;\n$layout-padding-extra-small: 8;\n$layout-padding-small: 16;\n$layout-padding-regular: 24;\n$layout-padding-large: 32;\n$layout-margin-small: 16;\n$layout-margin-regular: 32;\n\n/*\n* ------------------------------------------------------------------------------\n* Icon sizes\n* ------------------------------------------------------------------------------\n*/\n$icon-extra-small: 8;\n$icon-extra-small: 16;\n$icon-extra-medium: 24;\n$icon-extra-large: 40;\n\n/*\n* ------------------------------------------------------------------------------\n* Shape\n* ------------------------------------------------------------------------------\n*/\n$border-radius-extra-small: 4;\n\n/*\n* ------------------------------------------------------------------------------\n* Breakpoints\n* ------------------------------------------------------------------------------\n*/\n$breakpoint-small: 480;\n$breakpoint-medium: 769;\n$breakpoint-large: 1023;\n$breakpoint-extra-large: 1440;\n","@import \"variables\";@import \"mixins\";\n@import './fonts.scss';\n@import './main.scss';\n@import './globals.scss';\n@import './mixins.scss';\n@import './animations.scss';\n@import './theme-classes.scss';\n","$prefixes: \"webkit\", \"moz\", \"ms\", \"o\", \"none\";\n\n@mixin object-fit($object-fit) {\n  -o-object-fit: $object-fit;\n  object-fit: $object-fit;\n}\n\n@mixin transform($property) {\n  -webkit-transform: $property;\n  -ms-transform: $property;\n  transform: $property;\n}\n\n@mixin appearance($appaerence) {\n  -webkit-appearance: $appaerence;\n  -moz-appearance: $appaerence;\n  appearance: $appaerence;\n}\n\n@mixin prefix($property, $arguments) {\n  @each $prefix in $prefixes {\n    @if $prefix == \"none\" {\n      #{$property}: $arguments;\n    } @else {\n      -#{$prefix}-#{$property}: $arguments;\n    }\n  }\n}\n\n@mixin linkButton() {\n  background: none;\n  width: auto;\n  height: auto;\n  border: none;\n  cursor: pointer;\n  color: $green-link;\n  text-decoration: underline;\n  font-size: 16px;\n  margin: auto;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n/*\n* NOTE: The width and style of the font has been set using font-face in the fonts.scss\n* file. However, when the main font cannot be loaded those styles are not applied to\n* the optional fonts, because they must be specified each time the font styles are\n* assigned. To ensure the correct styles are applied, this mixin should be used.\n*/\n@mixin fontFamily($fontFamily) {\n  @if $fontFamily == 'Roboto' {\n    font-family: 'Roboto', arial, sans-serif;\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoItalic' {\n    font-family: 'RobotoItalic', arial, sans-serif;\n    font-weight: 400;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoMedium' {\n    font-family: 'RobotoMedium', arial, sans-serif;\n    font-weight: 500;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoMediumItalic' {\n    font-family: 'RobotoMediumItalic', arial, sans-serif;\n    font-weight: 500;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoBold' {\n    font-family: 'RobotoBold', arial, sans-serif;\n    font-weight: 700;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoBoldItalic' {\n    font-family: 'RobotoBoldItalic', arial, sans-serif;\n    font-weight: 700;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoCondensed' {\n    font-family: 'RobotoCondensed', arial, sans-serif;\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoCondensedItalic' {\n    font-family: 'RobotoCondensedItalic', arial, sans-serif;\n    font-weight: 400;\n    font-style: italic;\n  }\n\n  @if $fontFamily == 'RobotoCondensedBold' {\n    font-family: 'RobotoCondensedBold', arial, sans-serif;\n    font-weight: 700;\n    font-style: normal;\n  }\n\n  @if $fontFamily == 'RobotoCondensedBoldItalic' {\n    font-family: 'RobotoCondensedBoldItalic', arial, sans-serif;\n    font-weight: 700;\n    font-style: italic;\n  }\n}\n\n/*\n* NOTE: The following mixin can be used to calculate the size of any css property\n* in rem, however, the design system defines that only the font sizes would be\n* calculated in REM to give the user the opportunity to change the size by\n* configuring the browser.\n*/\n@mixin toRem($property, $value, $unit: $sizing-unit-base) {\n  #{$property}: ($value / $unit) + rem;\n}\n","@font-face {\n  font-family: 'Roboto';\n  src: url('../assets/fonts/Roboto-Regular.ttf');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'RobotoItalic';\n  src: url('../assets/fonts/Roboto-Italic.ttf');\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'RobotoMedium';\n  src: url('../assets/fonts/Roboto-Medium.ttf');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'RobotoMediumItalic';\n  src: url('../assets/fonts/Roboto-MediumItalic.ttf');\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'RobotoBold';\n  src: url('../assets/fonts/Roboto-Bold.ttf');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'RobotoBoldItalic';\n  src: url('../assets/fonts/Roboto-BoldItalic.ttf');\n  font-weight: 700;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'RobotoCondensed';\n  src: url('../assets/fonts/RobotoCondensed-Regular.ttf');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'RobotoCondensedItalic';\n  src: url('../assets/fonts/RobotoCondensed-Italic.ttf');\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'RobotoCondensedBold';\n  src: url('../assets/fonts/RobotoCondensed-Bold.ttf');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'RobotoCondensedBoldItalic';\n  src: url('../assets/fonts/RobotoCondensed-BoldItalic.ttf');\n  font-weight: 700;\n  font-style: italic;\n}\n",":global(html) {\n  /*\n  * NOTE: Only in this case should the third parameter be sent to toRem mixin.\n  * The base font size unit is 14px, this was defined by our designer, but\n  * in this case we are calculating the size of the html element and calculation\n  * is done based on the browser unit which is 16px is most cases.\n  */\n  font-size: 16px;\n  @include fontFamily('Roboto');\n\n  height: 100%;\n  scroll-behavior: smooth;\n  color: map-get($typography-body1, 'color');\n  letter-spacing: map-get($typography-body1, 'letter-spacing') + px;\n}\n\n:global(body) {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  background-color: $gray;\n}\n\n:global(strong) {\n  @include fontFamily('RobotoBold');\n}\n\n:global(b) {\n  @include fontFamily('RobotoBold');\n}\n\n:global(p) {\n  @include toRem('font-size', 14);\n}\n\n:global(span) {\n  @include toRem('font-size', 14);\n}\n\n:global(#app) {\n  height: 100%;\n  width: 100%;\n}\n\n:global(*) {\n  box-sizing: border-box;\n}\n","$sizing-unit-base: 16;\n\n// Screen sizes\n$large-screen: 1440px;\n$regular-screen: 1280px;\n$small-screen: 1023px;\n$horizontal-tablet: $small-screen;\n$vertical-tablet: 769px;\n$big-mobile: 576px;\n$mobile: 480px;\n$medium-mobile: 375px;\n$small-mobile: 320px;\n\n// Product colors\n$primary-color: #ff5a60;\n$secondary-color: #0477c0;\n$error-color: #ae3c40;\n$success-color: #3ab398;\n$border-color: #e1e1e1;\n$app-bg-color: #f8f8f8;\n\n// Screen Loaders\n$grey-placeholder: #e7e8e9;\n\n// Colors\n$green: #48b83b;\n$cerulean: #0477c0;\n$blue-link: #4087e8;\n$blue-link2: #1C64EB;\n$blue-ocean: #298de1;\n$greeny-blue: rgb(58, 179, 152);\n$green-link: #5a9c8f;\n$white: #ffffff;\n$white-one: #fefefe;\n$white-two: #d8d8d8;\n$white-eleven: $app-bg-color;\n$white-twelve: #f4f4f4;\n$white-alt: #fbfbfb;\n$gray: #f8f8f8;\n$border-grey: #cbcbcb;\n$weak-grey: #7e7c7c;\n$warm-grey: #9b9b9b;\n$warm-grey-two: #9c9c9c;\n$warm-grey-three: #898989;\n$strong-grey: #757171;\n$disabled-grey: #edebeb;\n$greyish-brown: #3e3e3e;\n$greyish-light: #5f5f5f;\n$light-grey: #a6a6a6;\n$soft-pink: #feabae;\n$light-pink: #ffeaea;\n$very-light-pink: #fff4f4;\n$orange: #edab41;\n$rust-orange: #c17f15;\n$red-error: #a1062c;\n$red-error-main: #D40707;\n$red-error-light: #FBDCDC;\n$white-seven: #f9f9f9;\n$white-eight: #dedede;\n$dark-sky-blue: #4a90e2;\n$coral: #f05754;\n$very-light-blue: #f3faf9;\n$tomato: #f53923;\n$dark-background-with-transparency: rgba(0, 0, 0, 0.6);\n$blueDarker: #034D8C;\n$blueDark: #0267BD;\n$blue: #0178DD;\n$blueLight: #3CA4FC;\n$blueLighter: #5DAFF5;\n$backgroundColor1: #E7F4FF;\n\n\n// toast colors\n$primary: #ff5a60;\n$warning: #f5a623;\n$sucess: #7ed321;\n$danger: #a1062c;\n$info: #0178dd;\n$primary-dark: #CE2E33;\n\n// simulator\n$investment-blue: #2dc1d4;\n\n// Button\n$button-border-radius: 24px;\n$button-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n\n// Card\n$card-border-radius: 5px;\n$card-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12),\n  0 0 2px 0 rgba(0, 0, 0, 0.14);\n$card-background-color: $white;\n\n// Table\n$alternate-row: #f1f1f1;\n$header-background: $warm-grey-two;\n\n// Panel\n$panel-border: 1px solid #e3e3e3;\n\n// Modal\n$modal-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12),\n  0 0 2px 0 rgba(0, 0, 0, 0.14);\n\n// Application\n$main-container-padding: 0 15px;\n\n// Application / Header\n$header-height: 75px;\n$header-bg-color: #fafafa;\n\n// Application / Sidenav\n$sidenav-width: 150px;\n$sidenav-bg-color: $white;\n$sidenav-item-height: 63px;\n\n// Application / Tabs\n$tab-border-radius: 3px;\n$active-tab-bg-color: $primary-color;\n$inactive-tab-bg-color: $border-grey;\n\n// Application / Mobile menu\n$header-height: 72px;\n$acount-info-height: 63px * 2;\n$nav-top: $header-height + $acount-info-height;\n\n// Enrollment / Sidenav\n$enrollment-sidenav-width: 296px;\n\n@import './theme-variables.scss';\n",":global {\n  .flex {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n  }\n\n  .flex-column {\n    flex-direction: column;\n  }\n\n  .align-center {\n    align-items: center;\n  }\n  \n  .align-self-center {\n    align-self: center;\n  }\n\n  .space-between {\n    justify-content: space-between;\n  }\n\n  .block {\n    display: block;\n  }\n\n  .grid {\n    display: -ms-grid;\n    display: grid;\n  }\n\n  .row {\n    width: 100%;\n    display: block;\n    clear: both;\n  }\n\n  .margin-0 {\n    margin: 0;\n  }\n\n  .margin-t-1 {\n    margin-top: 0.5rem;\n  }\n\n  .margin-t-2 {\n    margin-top: 0.75rem;\n  }\n\n  .margin-t-3 {\n    margin-top: 1rem;\n  }\n\n  .margin-t-4 {\n    margin-top: 1.25rem;\n  }\n\n  .margin-t-5 {\n    margin-top: 1.5rem;\n  }\n\n  .margin-t-6 {\n    margin-top: 1.75rem;\n  }\n\n  .margin-t-7 {\n    margin-top: 2rem;\n  }\n\n  .margin-r-1 {\n    margin-right: 0.5rem;\n  }\n\n  .margin-r-2 {\n    margin-right: 0.75rem;\n  }\n\n  .margin-r-3 {\n    margin-right: 1rem;\n  }\n\n  .margin-r-4 {\n    margin-right: 1.25rem;\n  }\n\n  .margin-r-5 {\n    margin-right: 1.5rem;\n  }\n\n  .margin-r-6 {\n    margin-right: 1.75rem;\n  }\n\n  .margin-r-7 {\n    margin-right: 2rem;\n  }\n\n  .margin-b-1 {\n    margin-bottom: 0.5rem;\n  }\n\n  .margin-b-2 {\n    margin-bottom: 0.75rem;\n  }\n\n  .margin-b-3 {\n    margin-bottom: 1rem;\n  }\n\n  .margin-b-4 {\n    margin-bottom: 1.25rem;\n  }\n\n  .margin-b-5 {\n    margin-bottom: 1.5rem;\n  }\n\n  .margin-b-6 {\n    margin-bottom: 1.75rem;\n  }\n\n  .margin-b-7 {\n    margin-bottom: 2rem;\n  }\n\n  .margin-l-1 {\n    margin-left: 0.5rem;\n  }\n\n  .margin-l-2 {\n    margin-left: 0.75rem;\n  }\n\n  .margin-l-3 {\n    margin-left: 1rem;\n  }\n\n  .margin-l-4 {\n    margin-left: 1.25rem;\n  }\n\n  .margin-l-5 {\n    margin-left: 1.5rem;\n  }\n\n  .margin-l-6 {\n    margin-left: 1.75rem;\n  }\n\n  .margin-l-7 {\n    margin-left: 2rem;\n  }\n\n  .text-error {\n    font-size: 13px;\n    @include fontFamily('Roboto');\n    margin-bottom: 0;\n    text-align: center;\n    color: $red-error;\n  }\n\n  .required-symbol {\n    color: $primary-color;\n  }\n}\n\n","@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    transform: translateX(500px);\n    opacity: 0.5;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutRight {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateX(500px);\n  }\n}\n","/*\n* This file contains global classes based in the theme defined by 100 Ladrillos\n* design system.\n*/\n\n:global {\n  .h1 {\n    @include toRem('font-size', map-get($typography-h1, 'font-size'));\n    @include fontFamily(map-get($typography-h1, 'font-family'));\n\n    color: map-get($typography-h1, 'color');\n    letter-spacing: map-get($typography-h1, 'letter-spacing') + px;\n  }\n\n  .h2 {\n    @include toRem('font-size', map-get($typography-h2, 'font-size'));\n    @include fontFamily(map-get($typography-h2, 'font-family'));\n\n    color: map-get($typography-h2, 'color');\n    letter-spacing: map-get($typography-h2, 'letter-spacing') + px;\n  }\n\n  .h3 {\n    @include toRem('font-size', map-get($typography-h3, 'font-size'));\n    @include fontFamily(map-get($typography-h3, 'font-family'));\n\n    color: map-get($typography-h3, 'color');\n    letter-spacing: map-get($typography-h3, 'letter-spacing') + px;\n  }\n\n  .subtitle {\n    @include toRem('font-size', map-get($typography-subtitle, 'font-size'));\n    @include fontFamily(map-get($typography-subtitle, 'font-family'));\n\n    color: map-get($typography-subtitle, 'color');\n    letter-spacing: map-get($typography-subtitle, 'letter-spacing') + px;\n  }\n\n  .body1 {\n    @include toRem('font-size', map-get($typography-body1, 'font-size'));\n    @include fontFamily(map-get($typography-body1, 'font-family'));\n\n    color: map-get($typography-body1, 'color');\n    letter-spacing: map-get($typography-body1, 'letter-spacing') + px;\n  }\n\n  .body2 {\n    @include toRem('font-size', map-get($typography-body2, 'font-size'));\n    @include fontFamily(map-get($typography-body2, 'font-family'));\n\n    color: map-get($typography-body2, 'color');\n    letter-spacing: map-get($typography-body2, 'letter-spacing') + px;\n  }\n\n  .body3 {\n    @include toRem('font-size', map-get($typography-body3, 'font-size'));\n    @include fontFamily(map-get($typography-body3, 'font-family'));\n\n    color: map-get($typography-body3, 'color');\n    letter-spacing: map-get($typography-body3, 'letter-spacing') + px;\n  }\n\n  .card {\n    background-color: $hbBackgroundA;\n    border: 1px solid $shape;\n    border-radius: $border-radius-extra-small + px;\n    box-sizing: border-box;\n    box-shadow: 0 0 6px 0 rgba(243, 243, 243, 0.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fadeIn": `frontend_web-app_src_sass_fadeIn`,
	"fadeInRight": `frontend_web-app_src_sass_fadeInRight`,
	"fadeOutRight": `frontend_web-app_src_sass_fadeOutRight`
};
export default ___CSS_LOADER_EXPORT___;
